// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const updateMccQuestions = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().mccQuestions, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_MCC_FOLLOWUP_MCC_QUESTIONS]: updateMccQuestions
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/reducers/mcc-questions.js